import styled from 'styled-components';

export const Wrap = styled.div`
  z-index: 999;
  position: fixed;
  top: 4px;
  left: 4px;
  display: flex;
  flex-direction: column;
  color: #fff;
  gap: 4px;
`;

export const DevButton = styled.button`
  width: 32px;
  background: #32c9c0;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 2px 4px;
  outline: none;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
`;

export const ContentWrap = styled.div`
  padding: 16px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.8);
  border: 1px solid #32c9c0;
  width: 320px;
`;

export const RowWrap = styled.div`
  display: flex;
  align-items: center;
`;

export const Label = styled.span`
  min-width: 100px;
  font-size: 14px;
  line-height: 24px;
`;

export const RadioWrap = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;

  button {
    cursor: pointer;
    border-radius: 10px;
    background: none;
    border: 1px solid #888;
    color: #888;
    font-size: 14px;
    padding: 2px 8px;

    &.active {
      border: 1px solid #32c9c0;
      color: #32c9c0;
    }
  }

  label {
    font-size: 14px;
    display: flex;
    align-items: center;
  }

  input[type='radio'] {
    accent-color: #32c9c0;
    margin: 0 2px 1px 0;
  }
`;

export const InputWrap = styled.div`
  input {
    border-radius: 10px;
    background: none;
    border: 1px solid #888;
    color: #eee;
    font-size: 14px;
    padding: 2px 8px;

    &:focus {
      border: 1px solid #32c9c0;
      outline: none;
    }
  }
`;

export const RefreshButton = styled.button`
  background: #32c9c0;
  color: #fff;
  border-radius: 8px;
  border: none;
  width: 100%;
  padding: 8px;
  font-size: 14px;
  font-weight: 500;
  margin-top: 8px;
  cursor: pointer;
  font-family: 'HGGGothicssi', 'Pretendard', 'Noto Sans', sans-serif;
`;
